import utils from '../../utils/util';
import BrowserEnvironment from './browser.environment';
class AutohomeEnvironment extends BrowserEnvironment {
  constructor () {
    super();
    this.appCustomerShareCallbacks = [];
    const ahappScriptUrl = 'https://g.autoimg.cn/@app/webview/ahapp-3.0.min.js?cache_ttl=3600&ahapp.js' ;
    this.scriptPromise = new Promise(function (resolve) {
      utils.loadScript({
        cross: true,
        id: 'ahapp-2.0',
        src: ahappScriptUrl,
        callback: function () {
          if (window._AHAPP && window._AHJavascriptBridge) {
            window._AHAPP.noConflict();
            window._AHJavascriptBridge.noConflict();
          }
          resolve();
        }
      });
    });
  }
  getEnvInfo () {
    return this.scriptPromise.then(() => {
      return { env: 'autoapp' };
    });
  }
  subscribe ({ init, shareSuccess, showCustomerShare }) {
    super.subscribe({ init, shareSuccess });
    this.appCustomerShareCallbacks.push(showCustomerShare);
  }

  /**
   * 设置分享数据
   * @param {*} opts
   */
  setShareData (opts) {
    super.setShareData(opts);
    let self = this;
    const criticalVersion = 1090; //支持自定义右上角图片按钮列表的版本,参见wiki:http://wiki.corpautohome.com/pages/viewpage.action?pageId=80987615
    self.handleWithVersion(
      criticalVersion,
      self.setCustomizeShare.bind(self),
      self.setNativeShare.bind(self)
    );
  }

  setShareBarHide () {
    let AHAPP = window.AHAPP;
    try {
      AHAPP.invokeNative('actionbarinfo', {
        //stablemenulist: [''],
        success: function () {
          console.log('');
        },
        fail: function (error) {
          console.log(JSON.stringify(error));
        }
      });
    } catch (ex) {
      console.error(ex);
    }
  }

  setNativeShare () {
    const self = this;
    const shareData = self.getShareData();
    self.scriptPromise.then(function () {
      let AHAPP = window.AHAPP;
      try {
        AHAPP.invokeNative('actionbarinfo', {
          title: shareData.title,
          stablemenulist: ['share'],
          success: function (res) {
            console.log(res);
          },
          fail: function (error) {
            console.log(JSON.stringify(error));
          }
        });
        // let shareUrl = shareData.link;
        window.AHJavascriptBridge.bindMethod('getshareinfo', function (
          args,
          callback
        ) {
          var json = {
            platform: 'all',
            url: shareData.link,
            title: shareData.title,
            content: shareData.desc,
            imgurl: shareData.icon,
            // options: {
            //   wx_mini_program: {
            //     userName: 'gh_bfcd071dba17',
            //     path:
            //       'package/pages/h5/index/index?url=' +
            //       encodeURIComponent(shareUrl)
            //   }
            // }
          };
          callback(json);
        });
        AHAPP.setNativeShareFinish({
          success: function () {
            self.execute(self.shareSuccessCallbacks);
          },
          fail: function (error) {
            console.log(JSON.stringify(error));
          }
        });
      } catch (ex) {
        console.error(ex);
      }
    });
  }

  setCustomizeShare () {
    const self = this;
    this.scriptPromise.then(function () {
      //目前最多只支持一个按钮
      window.AHAPP.invokeNative('actionbarinfo', {
        customimagebuttonlist: [
          {
            imgurl:
              'https://x.autoimg.cn/dealer/smartstore/assets/imgs/shareicon.png',
            callbackjs: 'shareIconClick'
          }
        ],
        success: function (result) {
          console.log(JSON.stringify(result)); //打印客户端返回的参数内容,该按钮点击也会回调此处
        },
        fail: function (result) {
          console.log(JSON.stringify(result));
        }
      });

      //点击右上角图标回调
      window.AHJavascriptBridge.bindMethod('shareIconClick', function (args) {
        console.log('js：' + JSON.stringify(args));
        self.showShare();
      });
    });
  }

  /**
   * 展示分享面板
   * @param {Object} opts
   */
  showShare (opts = { isNative: false }) {
    const self = this;
    //如果指定原生分享，唤起原生分享，反之以h5分享是否支持图片分享为版本（10.3.0）临界进行控制
    if (opts.isNative) {
      self.showNativeShare(opts);
    } else {
      const criticalVersion = 1030; //支持图片分享的版本
      self.handleWithVersion(
        criticalVersion,
        () => { this.execute(self.appCustomerShareCallbacks); },
        self.showNativeShare.bind(self, opts)
      );
    }
  }

  /**
   * 保存分享图片
   */
  saveShareImage (opts) {
    this.scriptPromise.then(function () {
      window.AHAPP.invokeNative('saveImgToSystemAlbum', {
        imgUrl: opts.imgUrl,
        success: function (result) {
          console.log('success' + JSON.stringify(result)); // 打印客户端返回的参数内容
          opts.callback();
        },
        fail: function (result) {
          console.log('fail' + JSON.stringify(result));
        }
      });
    });
  }

  /**
   * 根据主软版本控制执行逻辑
   * @param {Number} criticalVersion 临界版本
   * @param {Function} fitVersionCallback 匹配版本逻辑
   * @param {Function} lowVersionCallback 低版本逻辑
   */
  handleWithVersion (criticalVersion, fitVersionCallback, lowVersionCallback) {
    const version = utils.getAppVersionNum();
    if (version >= criticalVersion) {
      fitVersionCallback();
    } else {
      lowVersionCallback();
    }
  }

  /**
   * 打开原生分享面板
   */
  showNativeShare (
    options = {
      platform: 'all',
      binaryimage: '',
      shareUrl: '',
      hideMiniProgram: false
    }
  ) {
    let self = this;
    let shareData = this.getShareData();
    let params = {
      platform: options.platform,
      url: options.shareUrl || shareData.link,
      imgurl: options.icon || shareData.icon
    };

    if (options.binaryimage && options.binaryimage.length > 0) {
      params.binaryimage = options.binaryimage;
    } else {
      params.title = options.title || shareData.title;
      params.content = options.desc || shareData.desc;
      // if (!options.hideMiniProgram) {
      //   console.log('!options.hideMiniProgram');
      //   params.options = {
      //     wx_mini_program: {
      //       userName: 'gh_bfcd071dba17',
      //       path:
      //         'package/pages/h5/index/index?url=' +
      //         encodeURIComponent(shareData.link)
      //     }
      //   };
      // }
    }
    this.scriptPromise.then(function () {
      window.AHAPP.invokeNative('h5share', {
        ...params,
        success: function () {
          if (
            options.shareCallback &&
            typeof options.shareCallback === 'function'
          ) {
            options.shareCallback();
          }
          self.execute(self.shareSuccessCallbacks);
        },
        fail: function (error) {
          console.log(JSON.stringify(error));
        }
      });
    });
  }

  /**
   * 打开直播页面
   * @param {roomId, sourceId} roomId 房间id, sourceId 来源id,showType 1 横屏 2 竖屏
   */
  openLive ({ roomId, pvareaid, showType }) {
    let goH5Live = () => super.openLive({ roomId, pvareaid });
    let cookie = utils.getCookie('app_ver') || '0';
    let version = +cookie.split('.').join('');
    version = parseInt(version, 10);
    if (version >= 1065) {
      let liveMode = 'liveshowvertical';
      if (showType === 1) {
        liveMode = 'liveshowdetail';
      }
      let url = `autohome://liveshow/${liveMode}?roomid=${roomId}&sourceid=80010&frompv=${pvareaid}`;
      this.scriptPromise.then(function () {
        window.AHAPP.invokeNative('nativepage', {
          url: url,
          success: function (res) {
            console.log(res);
          },
          fail: function (error) {
            console.log(JSON.stringify(error));
          }
        });
      });
    } else {
      goH5Live();
    }
  }
  /**
   * autohome://insidebrowser?url=
   * autohome://insidebrowserwk?url=
   * * 打开新页面
   * * @param {*} param0
   * */
  openPage ({ url }) {
    window.location = `autohome://insidebrowserwk?url=${encodeURIComponent(
      url
    )}`;
  }
  setIsIntercept (isIntercept) {
    this.isIntercept = isIntercept;
  }
  bindIntercept (actions) {
    let self = this;
    this.scriptPromise.then(function () {
      window.AHJavascriptBridge.bindMethod('interceptH5ClickEvent', function (
        args,
        callback
      ) {
        if (!self.isIntercept) { return; }
        if (args) {
          // H5针对是返回或关闭事件的相应逻辑处理
          actions.forEach(action => {
            action(args);
          });
        }
        // H5 指定超时时间内返回原生回调
        if (callback) {
          if (self.isIntercept) {
            callback('interceptback');
          } else {
            callback();
          } // 如果想进行拦截在callback中传入任意值，如 callback("111")；如里不拦截不传返回值 callback()。
        }
      });
    });
  }
  back () {
    let self = this;
    self.scriptPromise.then(function () {
      window.AHAPP.invokeNative('pop', {
        success: function () {
          return;
        },
        fail: function () {
          return;
        }
      });
    });
  }
  /**
   * 原生登录
   */
  login () {
    return this.scriptPromise.then(function () {
      return new Promise(function (resolve, reject) {
        window.AHAPP.invokeNative('login', {
          success: function (result) {
            resolve(result);
          },
          fail: function (result) {
            reject(result);
          }
        });
      });
    });
  }
  // 没有找到调用的地方
  openMiniProgram ({ userName, miniAppPath }) {
    this.scriptPromise.then(function () {
      window.AHAPP.invokeNative('h5share', {
        platform: 'weixin', //分享平台,all 为所有支持的平台
        wx_mini_program: { userName: userName, path: miniAppPath },
        success: function (result) {
          console.log('success' + JSON.stringify(result)); // 打印客户端返回的参数内容
        },
        fail: function (result) {
          console.log('fail' + JSON.stringify(result));
        }
      });
    });
  }

  /**
   * H5浏览器通用设置 wiki:http://wiki.corpautohome.com/pages/viewpage.action?pageId=198150722
   * @param {String} bounces 页面是否允许下拉true/false，默认是true。仅iOS有效
   * @param {String} interactivePopGesture 页面是否开启手势返回true/false，默认是true。仅iOS主软件11.11.0及以上有效
   */
  setupBrowser (bounces = 'false', interactivePopGesture = 'false') {
    window.AHAPP.invokeNative('setupBrowser', {
      bounces: bounces,
      interactivePopGesture: interactivePopGesture,
      success: function (result) {
        console.log(result);
      },
      fail: function (result) {
        console.log(result);
      }
    });
  }
  getDeviceinfo () {
   return this.scriptPromise.then(function () {
      return new Promise(function (resolve, reject) {
        window.AHAPP.invokeNative('getdeviceinfo', {
          deviceInfoPermissionDesc:
            '设备信息无法读取，为了保证您更好的体验，请授权开启',
          success: function (result) {
            if (result && Number(result.returncode) === 0 && result.result) {
              return resolve(result.result);
            } else {
              reject(result);
            }
          },
          fail: function (result) {
            reject(result);
          },
        });
      });
    });
  }
}

export default AutohomeEnvironment;
